import styled from '@emotion/styled';
import { colors, Stack, TabPanelContainer, Typography } from '@ui-components/neo.tax';
import { ReactComponent as CompanyIcon } from '@ui-components/neo.tax/dist/icons/company.svg';
import { ReactComponent as MembersIcon } from '@ui-components/neo.tax/dist/icons/members.svg';

import { NAV_HEIGHT } from '@neo.tax/shared/constants';

export const OrgDashboardContainer = styled(Stack)({
  backgroundColor: colors.gray[200],
  height: '100vh',
  padding: '0 1.5rem',
  paddingTop: NAV_HEIGHT,
});

export const ListContainer = styled(Stack)({
  height: '100%',
});

const iconStyle = {
  display: 'inline-block',
  height: '1.5rem',
  width: '1.5rem',
};

export const StyledCompanyIcon = styled(CompanyIcon)(iconStyle);

export const StyledMembersIcon = styled(MembersIcon)(iconStyle);

export const StyledTabLabel = styled(Typography)({
  color: 'inherit',
});

export const StyledTabPanelContainer = styled(TabPanelContainer)({
  height: '100%',
  paddingBottom: '4rem',
});
